import { observer } from "mobx-react";
import { IconVSign } from "../../../../components/icons/icon-v-sign/icon-v-sign";
import Icon from "../../../../components/icons/icon/icon";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import "./plan-info-line.scss";


interface IProps {
    lineText: string;
}

const PlanInfoLine: React.FC<IProps> = observer(({ lineText }: IProps) => {
    return(
        <div className="plan-info-line">
            <Icon Component={IconVSign} />
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{lineText}</FontBody1>
        </div>
    )
});

export default PlanInfoLine;